import React, { useState, useEffect } from "react";
import "../css/ProductList.css";

interface Product {
  id: number;
  name: string;
  image: string;
  description: string;
  category: string;
  subCategoryId: number;
}

interface SubCategory {
  id: number;
  name: string;
}

interface ProductListProps {
  title: string;
  products: Product[];
  subCategories: SubCategory[];
categoryName: string;
}

const ProductList: React.FC<ProductListProps> = ({ title, products, subCategories,categoryName }) => {
  const [category, setCategory] = useState<string | null>(null);

  useEffect(() => {
    const getCategoryFromHash = () => {
      const hash = window.location.hash.split("/");
      if (hash.length >= 4) {
        // setCategory(decodeURIComponent(hash[2])); // "Mechanical"
        setCategory(decodeURIComponent(hash[3])); // "Pipe"
      }
      else if (hash.length >= 2) {
        setCategory(decodeURIComponent(hash[2])); // "Pipe
      }
    };

    getCategoryFromHash();
    window.addEventListener("hashchange", getCategoryFromHash);

    return () => {
      window.removeEventListener("hashchange", getCategoryFromHash);
    };
  }, []);

  // Filter products based on category
  console.log(categoryName,category);
  const filteredProducts = category
    ? products.filter((product) => product.category.toLowerCase() === category.toLowerCase() || decodeURIComponent(categoryName) === decodeURIComponent(category))
    : products;

  // Group products by subcategory
  const groupedProducts: Record<string, Product[]> = {};
  
  filteredProducts.forEach((product) => {
    const subCategoryName = subCategories.find((sub) => sub.id === product.subCategoryId)?.name || "Other";
    if (!groupedProducts[subCategoryName]) {
      groupedProducts[subCategoryName] = [];
    }
    groupedProducts[subCategoryName].push(product);
  });

  return (
    <div className="product-page">
      <div className="product-header">{category ? `${decodeURIComponent(category)} Products` : title}</div>
      <div className="product-container">
        {Object.entries(groupedProducts).map(([subCategory, products]) => (
          <div key={subCategory} className="subcategory-section">
           { subCategory!='Other' && ( <h2 className="subcategory-title">{subCategory}</h2>)}
            <div className="product-grid">
              {products.map((product) => (
                <div key={product.id} className="product-card">
                     <div className="product-image-container">
                  <img src={product.image} alt={product.name} />
                  </div>
                   <div className="product-info">
                    <h3 className="product-title">{product.name}</h3>
                    {/* <p className="product-description">{product.description}</p> */}
                   </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductList;
